import React from 'react';
import PropTypes from 'prop-types';

function Avatar({ name = '', role = '', src, style, className }) {
  if (src) {
    let extraClass = className || 'avatar';
    return (
      <img
        src={src}
        alt={name}
        className={`${extraClass} rounded-circle`}
        style={{ objectFit: 'cover', ...style }}
      />
    );
  }

  let nameArr = (name || '').trim().split(' ');
  let initials = '';
  if (nameArr?.[0]?.[0]) {
    initials += nameArr[0][0];
  }
  if (nameArr?.[1]?.[0]) {
    initials += nameArr[1][0];
  }

  let avatarClass = className || 'avatar';
  if (!className || !className.includes('blue') && !className.includes('red') && !className.includes('green') && !className.includes('orange') && !className.includes('purple')) {
    if (role === 'engineer') {
      avatarClass += ' blue';
    } else if (role === 'admin') {
      avatarClass += ' red';
    } else if (role === 'quality') {
      avatarClass += ' green';
    } else if (role === 'contractor') {
      avatarClass += ' orange';
    } else if (role === 'manager') {
      avatarClass += ' purple';
    }
  }

  return (
    <div className={avatarClass} style={style}>
      {initials || '?'}
    </div>
  );
}

Avatar.propTypes = {
  name: PropTypes.string,
  role: PropTypes.string,
  src: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Avatar;
